import { isDefined } from '@sgme/fp';
import { useLayoutEffect, useRef } from 'react';

export function useLayoutEffectWithRef<THtmlElt extends HTMLElement>(effect: (elt: THtmlElt) => void) {
  const myRef = useRef<THtmlElt>(null);
  const currentRef = myRef.current;
  useLayoutEffect(() => {
    if (isDefined(currentRef)) {
      effect(currentRef);
    }
  }, [effect, currentRef]);

  return myRef;
}
